import React from 'react';
import classnames from 'classnames';
import { getDeviationType } from '../../../../_helpers';
import { DeviationTypes } from '../../../../../types/deviation';
import FaveButton from '../../../../../FaveButton';
import FavouriteIcon from '../../../../../Icons/Favourite';
import OverlayControl from './OverlayControl';
import s from '../Overlay.scss';
var FaveControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, faveCount = _a.faveCount, iconType = _a.iconType;
    var deviationType = getDeviationType(deviation);
    var isFaveable = ![
        DeviationTypes.COMMISSION,
        DeviationTypes.POLL,
        DeviationTypes.STATUS,
    ].includes(deviationType);
    if (!isFaveable) {
        return null;
    }
    return (React.createElement(OverlayControl, { stat: faveCount, title: "faves", className: className, iconType: iconType },
        React.createElement(FaveButton, { deviation: deviation, className: classnames(s['icon-button'], deviation.isFavourited && s['active-bg']) }, function (renderProps) { return (React.createElement(FavouriteIcon, { className: classnames(s['icon'], renderProps.isFavourite && s['active']) })); })));
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=Fave.js.map